import { ChipTypesConstants } from "constants/DefectDetails";

const me =
	(localStorage.getItem("me") && JSON.parse(sessionStorage.getItem("me"))) ||
	(localStorage.getItem("me") && JSON.parse(localStorage.getItem("me")));
export const ChipTypes = (id) => {
	return ChipTypesConstants(me?.customCaptions)?.filter(
		(item) => item?.id === id
	);
};
